import { render, staticRenderFns } from "./LabsIndex.vue?vue&type=template&id=6dbc3b04&scoped=true&"
import script from "./LabsIndex.vue?vue&type=script&lang=js&"
export * from "./LabsIndex.vue?vue&type=script&lang=js&"
import style0 from "./LabsIndex.vue?vue&type=style&index=0&id=6dbc3b04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc3b04",
  null
  
)

export default component.exports